import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { initRacing, getSchedule, unregisterWsUpdate, setIsStreaming } from '../actions/racing';
import Racing from '../components/Racing';

/**
 * React-redux bindings
 * @param {*} state the current state
 * @returns {object} props
 */
function mapStateToProps(state) {
    return {
        racingData: state,
    };
}

/**
 * React-redux bindings
 * @param {*} dispatch the dispatcher function
 * @returns {object} betfeed actions
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators({ initRacing, getSchedule, unregisterWsUpdate, setIsStreaming }, dispatch);
}

const RacingContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Racing);

export default RacingContainer;
